import Vue from "vue";

const templateId = +document.body.getAttribute("data-tplId") || +document.body.getAttribute("tplid");
const templatePath = "./templates/" + templateId + "/singles.js";

let component = Vue.component("singles", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props: ['opt','jsonval'],
      data() {
        return {
          templateId:templateId,
          singlesel: 0,
          name: this.jsonval.anychoice,
          isLabel:false,
          isempty:true,
          istempty: 'ok-select -state-empty',
          isntempty: 'ok-select'
        }
      },
      created(){
        const urlParams = new URLSearchParams(window.location.search)
        this.singlesel = urlParams.get(this.opt.name) || 0
        if(parseInt(this.singlesel)){
          this.name = this.opt.options.filter((option)=>{
            return option.id==this.singlesel
          })[0].value
        }
      },
      computed:{
        labelclasstrue(){
          if (this.templateId > 35)
            return 'ok-form-label -state-active'
          return 'col-md-12 ok-label-static'
        },
        labelclassfalse(){
          if (this.templateId > 35)
            return 'ok-form-label'
          return 'col-md-12 ok-label-static -state-empty'

        },
      },
      methods: {
        ch(index) {
          this.singlesel=this.opt.options[index].id;
          this.name=this.opt.options[index].value;
          this.isLabel=true;
        },
        defaultvalue() {
          this.singlesel=0;
          this.name=this.jsonval.anychoice;
          this.isLabel=false;
        },
      },
      watch: {
        singlesel() {
          if (this.singlesel > 0) {
            this.isempty=false;
          } else {
            this.isempty=true;
          }
        },
      }
    });
  });
});
export default component;
